import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app'
import './index.css'
import './app/globals.css'
import * as Sentry from '@sentry/react'

const browserWindow = window as typeof window & {
    process?: { env?: Record<string, string | undefined> }
}

// react-draggable checks process.env during drag start in the browser bundle.
browserWindow.process = browserWindow.process ?? { env: {} }
browserWindow.process.env = browserWindow.process.env ?? {}

Sentry.init({
    dsn: 'https://88dee4768820c0444a3b9d18dc889010@o4510940265840640.ingest.us.sentry.io/4510940268855296',
    sendDefaultPii: true,
})

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
)
